import React from "react";
import styled from "styled-components";
import { Link as _Link } from "../../common/Link";
import Gettext from "../../common/Gettext";
import { StyledPopup as Popup } from "./Popup";
import * as TournamentIcon from "../../Icons/Tournaments";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.div`
  margin-bottom: 55px;
  font-size: 28px;
  font-weight: 700;
  color: #ffcc00;
  text-transform: uppercase;

  @media (max-width: 959px) {
    margin-bottom: 35px;
    font-size: 18px;
  }

  @media (orientation: landscape) and (max-width: 959px) {
    margin-bottom: 17px;
  }
`;

const IconContainer = styled.div`
  width: 130px;
  margin-bottom: 56px;

  @media (max-width: 959px) {
    margin-bottom: 45px;
  }

  @media (orientation: landscape) and (max-width: 959px) {
    width: 94px;
    margin-bottom: 18px;
  }
`;

const Message = styled.p`
  margin-bottom: 36px;
  color: ${({ theme }) => theme.suspiciousActivityPopupText};
  font-size: 18px;
  font-size: 700;
  text-align: center;

  @media (max-width: 959px) {
    margin-bottom: 18px;
  }
`;

const Footer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  margin-bottom: 20px;

  @media (max-width: 479px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const Button = styled(_Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 163px;
  min-height: 37px;
  padding: 8px 20px;
  font-size: 12px;
  font-weight: 900;
  color: ${({ theme }) => theme.suspiciousActivityPopupButton};
  text-transform: uppercase;
  text-decoration: none;
  background-color: transparent;
  border: 2px solid ${({ theme }) => theme.suspiciousActivityPopupButton};
  border-radius: 18px;
  transition: all 0.15s;

  &:hover {
    background-color: ${({ theme }) => theme.suspiciousActivityPopupButton};
    color: ${({ theme }) => theme.suspiciousActivityPopupButtonHoverColor};
  }

  @media (max-width: 479px) {
    margin-bottom: 16px;
  }
`;

const LaterButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const LaterButton = styled.button`
  display: block;
  padding: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.suspiciousActivityPopupLink};
  text-decoration: underline;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    text-decoration: none;
  }
`;

const SuspiciousActivityError = ({ onDismiss, onDismissAll, callback }) => {
  return (
    <Popup
      onDismiss={() => onDismiss({ callback })}
      fades={false}
      withWhiteTheme
    >
      <Container>
        <Title>
          <Gettext>Caution</Gettext>
        </Title>
        <IconContainer>
          <TournamentIcon.Caution />
        </IconContainer>
        <Message>
          <Gettext>
            We have detected some suspicious activity on your account. Please
            verify your account on the verification page to join tournaments.
          </Gettext>
        </Message>
        <Footer>
          <div />
          <Button
            to="/verification"
            onClick={() => {
              onDismiss({ callback });
              onDismissAll();
            }}
          >
            <Gettext>Verify</Gettext>
          </Button>
          <LaterButtonContainer>
            <LaterButton
              onClick={() => {
                onDismiss({ callback });
                onDismissAll();
              }}
            >
              <Gettext>Later</Gettext>
            </LaterButton>
          </LaterButtonContainer>
        </Footer>
      </Container>
    </Popup>
  );
};

export default SuspiciousActivityError;



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/SuspiciousActivityError.js